/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrApiVersionEnum } from './irrApiVersionEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { SubscriptionSpec } from './subscriptionSpec';


export interface DeploymentRegionLinkSpec { 
    /**
     * Force link will make this API idempotent and so that re-linking does not fail for duplicate records.
     */
    force_link?: boolean;
    /**
     * IP address of gateway
     */
    gateway_ip: string;
    /**
     * Create DNS entry in Route53
     */
    generate_dns_entry?: boolean;
    irr_api_version?: IrrApiVersionEnum;
    /**
     * Version of IRR. If specified, version will not be polled from EC2 instance. If skip_org_ip_validation is enabled, this value will be ignored.
     */
    irr_version?: string;
    /**
     * Should the FQDN scheme be old style (vcdr-35-165-175-28.staging.app.vcdr.vmware.com) or new (35-165-175-28-us-west-2.console.ds-stg.vmware.com). Also the IRR API version old vs new. This applies only for VCDR service type.
     */
    old_scheme?: boolean;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    service_type: ServiceTypeEnum;
    /**
     * Set to true when a fake IRR gateway IP is used (MOCK provider) and IRR config push should be skipped
     */
    skip_gateway_config?: boolean;
    /**
     * Operator can skip several level of org and Ip address validation to be less strict.
     */
    skip_org_ip_validation?: boolean;
    subscription?: SubscriptionSpec;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace DeploymentRegionLinkSpec {
}


